<template>
  <div>
    <Modal
      cancelText=""
      headerText="Import from CSV"
      mainActionText=""
      :visible="visible"
      @updateVisibility="handleUpdateVisibilityChanged"
    >
      <p :class="$style.modalBodyText">
        The CSV Import Template is pre-populated with columns for
        available user attributes within Jumpcloud.
      </p>
      <div :class="$style.iconContainer">
        <a
          :class="$style.link"
          href="javascript:void(0);"
          @click="downloadTemplate"
        >
          <DownloadIcon :class="$style.downloadIcon" />
          <span :class="$style.linkText">
            Download CSV Template
          </span>
        </a>
        <a
          :class="$style.link"
          href="javascript:void(0)"
          @click="showFileUploadModal"
        >
          <UploadIcon :class="$style.uploadIcon" />
          <span :class="$style.linkText">
            Upload CSV for Import
          </span>
        </a>
      </div>
      <slot />
    </Modal>
  </div>
</template>
<script>
import { eventLocations, eventProperties } from 'client/GrowthEngineering/utilities/GrowthConstants';
import DownloadIcon from 'public/img/icons/import_icon.svg?inline';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ImportUsersConstants from 'client/util/Constants/ImportUsersConstants';
import JobUtils from 'client/util/JobUtils';
import Modal from 'client/components/Modal/Modal.vue';
import UploadIcon from 'public/img/icons/export_icon.svg?inline';

const {
  description,
  location,
  section,
  text,
} = eventProperties;

export default {
  name: 'CSVOptionsModal',

  components: {
    Modal,
    DownloadIcon,
    UploadIcon,
  },

  props: {
    handleCancel: {
      default: () => {},
      type: Function,
    },
    showFileUploadModal: {
      default: () => {},
      type: Function,
    },
    visible: {
      default: false,
      type: Boolean,
    },
  },

  methods: {
    downloadTemplate() {
      EventHelper.triggerButtonClicked({
        [description]: 'Downloads a CSV Template',
        [location]: eventLocations.usersPage,
        [section]: 'Add your first user',
        [text]: 'Download CSV Template',
      });
      JobUtils.downloadCsvTemplate(ImportUsersConstants.csvImportTemplate, 'template');
    },

    handleUpdateVisibilityChanged(visibility) {
      if (visibility === false) {
        this.handleCancel();
      }
    },
  },
};
</script>
<style module scoped>
@value (greyLight7) from '~css/colors.css';

.link {
  display: block;
  padding: 15px;
  text-align: center;
}

.link:hover {
  background-color: greyLight7;
}

.linkText {
  display: block;
  margin-top: 10px;
}

.modalBodyText {
  margin-bottom: 2rem;
}

.iconContainer {
  display: flex;
  justify-content: space-around;
  padding-bottom: 2rem;
}

.uploadIcon {
  height: 48px;
  width: 50px;
}

.downloadIcon {
  height: 48px;
  width: 50px;
}

.uploadIcon g {
  fill: #81bc00;
}

.downloadIcon g {
  fill: #145d6b;
}
</style>
